/* eslint-disable no-shadow */
import React, { Component } from "react";
import axios from "axios";
import Parser from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import * as Sentry from "@sentry/react";
import Loading from "../loaders/Loading";
import Button from "../button/Button";
import {
  ModalBackdrop,
  Modal,
  Title,
  TitleText,
  CloseButton,
  BodyWrapper,
  Body,
  ButtonWrapper,
  TextError,
  Text,
} from "./styles/terms-and-privacy-modal-styles";

export interface Props {
  togglePrivacyModal: () => void;
}

type PrivacyPolicyBusiness = string;

interface State {
  loading: boolean;
  data?: PrivacyPolicyBusiness;
  error?: boolean;
}

export class PrivacyPolicyModal extends Component<Props, State> {
  state = {
    loading: true,
    data: null,
    error: false,
  };

  async componentDidMount(): Promise<void> {
    await this.fetchData();
  }

  fetchData = async (): Promise<void> => {
    const url = "/recruiter/privacy_policy";

    try {
      const { data }: { data: PrivacyPolicyBusiness } = await axios.get(url);

      this.setState({
        loading: false,
        data,
        error: false,
      });
    } catch (error) {
      this.setState({
        loading: false,
        error: true,
        data: null,
      });

      Sentry.captureException(error);
    }
  };

  render(): React.ReactNode {
    const { togglePrivacyModal } = this.props;
    /* eslint-disable  @typescript-eslint/no-unsafe-call */
    /* eslint-disable  @typescript-eslint/no-unsafe-assignment */
    const { loading, data, error } = this.state;
    /* eslint-enable  @typescript-eslint/no-unsafe-assignment */

    return (
      <ModalBackdrop>
        <Modal>
          {loading ? (
            <Loading fontSize="medium" />
          ) : (
            <BodyWrapper>
              <Title>
                <TitleText>Privacy Policy</TitleText>
                <CloseButton onClick={() => togglePrivacyModal()}>
                  <FontAwesomeIcon icon={faTimes} />
                </CloseButton>
              </Title>
              <Body>
                {error ? (
                  <TextError>Error loading data</TextError>
                ) : (
                  <Text>{Parser(data)}</Text>
                )}
              </Body>
              <ButtonWrapper>
                <Button
                  buttonName="Close"
                  primary
                  onClickAction={() => togglePrivacyModal()}
                />
              </ButtonWrapper>
            </BodyWrapper>
          )}
        </Modal>
      </ModalBackdrop>
    );
    /* eslint-enable  @typescript-eslint/no-unsafe-call */
  }
}

export default PrivacyPolicyModal;
